export default "__VITE_ASSET__7f64bc66__"